export default __webpack_public_path__ + "static/portal-57414c76656b36a1a54632d2cf5bf891.mp4";